import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DataListModel } from '../../models/data-list-model';
import { Observable } from 'rxjs';
import { CardCreationImport } from '../../dto/card-creation-import';

@Injectable({
  providedIn: 'root'
})
export class CardCreationImportService{
  readonly apiPath = 'card-creation-imports/';
  constructor(
      private http: HttpClient,
  ) {
   }

  getMany(
   pageIndex: number,
   pageSize: number,
   sortField: string,
   sortDirection: string,
   filterString: string,
 ): Observable<DataListModel<CardCreationImport>> {
   const params = new HttpParams()
   .set('page',            pageIndex.toString())
   .set('pageSize',        pageSize.toString())
   .set('filterString',    filterString)
   .set('sortField',       sortField)
   .set('sortDirection',   sortDirection);
     return this.http.get(this.apiPath, { params }) as Observable<DataListModel<CardCreationImport>>;
 }

  get(id: number): Observable<CardCreationImport> {
    return this.http.get(this.apiPath + id) as Observable<CardCreationImport>;
  }

  upload(file: File): Observable<CardCreationImport> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(this.apiPath + 'upload/', file) as Observable<CardCreationImport>;
  }

  add(item: CardCreationImport): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(id: number, item: CardCreationImport): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  delete(id: number): Observable<Object> {
    return this.deleteMany([id]);
  }

  restore(id: number): Observable<Object> {
    return this.http.patch(this.apiPath + id, null);
  }

  deleteMany(idList: number[]): Observable<Object> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }


  restoreMany(list: number[]): Observable<Object> {
    throw new Error('Method not implemented.');
  }
}
